import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  toggleButton(event) {
    if (!event.target.className) {
      console.error("target mist class");
    }
    const do_disable = !this.relatedCheckboxChecked(event);
    const button = document.getElementById(event.params.button);
    if (button) {
      button.disabled = do_disable;
    }
  }

  relatedCheckboxChecked(event) {
    let checked = false;
    const cssClass = event.target.className;
    const siblings = Array.from(document.getElementsByClassName(cssClass));
    if (siblings.length === 1 && event.target.checked) {
      return true;
    }
    siblings.forEach((sibling) => {
      if (sibling.checked) {
        checked = true;
      }
    });
    return checked;
  }

  toggleChildren(event) {
    const children = document.querySelectorAll(`.${event.params.class}`);
    children.forEach((child) => {
      child.checked = event.target.checked;
    });
  }

  toggleBound(event) {
    const bound = document.querySelectorAll(`.${event.params.bound}`);
    bound.forEach((bound) => {
      bound.checked = event.target.checked;
    });
  }
}
